var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("div", { staticClass: "loading_holder" }, [
        _c("div", { staticClass: "spinner_holder" }, [_c("c-spinner")], 1)
      ])
    : _c(
        "v-container",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "mb-5": "" } },
            _vm._l(_vm.arts, function(art) {
              return _c(
                "v-flex",
                {
                  key: art.id,
                  attrs: {
                    xs12: "",
                    lg10: "",
                    "offset-lg2": "",
                    "mt-5": "",
                    "mr-5": ""
                  }
                },
                [
                  _c(
                    "v-card",
                    { attrs: { "mt-3": "" } },
                    [
                      _c("v-card-media", {
                        attrs: { img: "", src: art.url, height: "450px" }
                      }),
                      _vm._v(" "),
                      _c("v-card-title", { attrs: { "primary-title": "" } }, [
                        _c("div", [
                          _c("h3", { staticClass: "headline mb-0" }, [
                            _vm._v(_vm._s(art.art_title))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                flat: "",
                                color: "primary",
                                router: "",
                                to: "/viewed_art"
                              },
                              on: {
                                click: function($event) {
                                  _vm.clicked_art(art.upload_date)
                                }
                              }
                            },
                            [_vm._v("View")]
                          ),
                          _vm._v(" "),
                          _c("v-spacer")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            })
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68130994", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68130994","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artists/viewed_artist_dashboard.vue
// module id = null
// module chunks = 